import { NIL as NIL_UUID } from 'uuid';
import { globalData } from '../models/manage/';
//import { Cookies } from 'quasar'; TODO: Cookies対応

/**
 * bootロジックの引数を型付けするためのインターフェイス。
 * 各パラメーターは下記参照。
 * https://quasar.dev/quasar-cli/boot-files#Anatomy-of-a-boot-file
 */
interface BootParameter {
  urlPath: string;
  redirect: (url: string) => void;
}

/**
 * ページ遷移処理をフックし、未ログインの場合は、ログイン画面に遷移する。
 * https://quasar.dev/quasar-cli/boot-files#Router-authentication
 */
export default (parameter: BootParameter) => {
  if (process.env.ROUTER_TYPE === 'manage') {
    if (globalData.sessionId === NIL_UUID && parameter.urlPath != '/signin') {
      parameter.redirect('/signin');
      return;
    }
  }
};
